export function PageHeader({ tag, title, description, action }) {
  return (
    <div className="border-b border-gray-200 pb-6 mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        {tag && <p className="veta-tag mb-2">{tag}</p>}
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter leading-none text-black">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-sm md:text-base text-gray-600 max-w-2xl">{description}</p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
